import routesFactory from './routes/routes'
import authModule from './store/module'
import { MODULE_NAME as AUTH_MODULE_NAME } from '@/global/auth/store/types'

import Vue from 'vue'

import SignIn from './components/SignIn.vue'
import ConfirmSignUp from './components/ConfirmSignUp.vue'
import RequireNewPassword from './components/RequireNewPassword.vue'
import ForgotPassword from './components/ForgotPassword.vue'
import Authenticator from './components/Authenticator.vue'
import Amplify from 'aws-amplify'

const VUE_APP_AWS_REGION = 'eu-west-1'
const VUE_APP_USER_POOL_ID = 'eu-west-1_8bgjvVYSy'
const VUE_APP_USER_POOL_CLIENT_ID = '7cdchj7prlgu4djsiccfm9r20l'

Amplify.configure({
  Auth: {
    region: VUE_APP_AWS_REGION,
    userPoolId: VUE_APP_USER_POOL_ID,
    userPoolWebClientId: VUE_APP_USER_POOL_CLIENT_ID
  }
})

Vue.component('ssp-authenticator', Authenticator)
Vue.component('ssp-sign-in', SignIn)
Vue.component('ssp-confirm-sign-up', ConfirmSignUp)
Vue.component('ssp-require-new-password', RequireNewPassword)
Vue.component('ssp-forgot-password', ForgotPassword)

export { Authenticator }

export const domainConfig = () => {
  return {
    vuex: [
      {
        name: AUTH_MODULE_NAME,
        moduleFactory: authModule
      }
    ],
    router: { routesFactory }
  }
}
